import { useEffect } from "react";
import { Link } from "react-router-dom";
import ContactForm from "../components/ContactForm";

export default function Contact() {
  useEffect(() => {
    document.title = "Kontakt – FYNS AFLØBSTEKNIK";
  }, []);

  return (
    <div className="bg-white min-h-screen text-neutral-900">
      {/* Header Banner */}
      <section className="bg-[#0d1117] text-white py-14 sm:py-20 border-b border-neutral-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl space-y-4">
            <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-neutral-400 font-bold">
              <Link to="/" className="hover:text-white transition-colors">Forside</Link>
              <span className="text-neutral-600">/</span>
              <span>Kontakt</span>
            </div>

            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white">
              Kontakt os
            </h1>

            <p className="text-neutral-300 text-base sm:text-lg leading-relaxed border-l-4 border-neutral-400 pl-4 py-1">
              Kontakt Fyns Afløbsteknik for en uforpligtende snak. Jeg overholder altid aftalte priser, betingelser og tidsfrister og leverer den kvalitet, dit hjem fortjener. Fyns Afløbsteknik ligger i Odenses nordøstligste bydel. Herfra kan jeg nå alle de fynske flækker.
            </p>
          </div>
        </div>
      </section>

      {/* Main Grid: Form + Kontaktinfo + Kort */}
      <section className="py-14 sm:py-20 bg-neutral-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
            
            {/* Venstre kolonne: Kontaktformular */}
            <div className="lg:col-span-7">
              <ContactForm
                title="Skriv til os"
                subtitle="Udfyld formularen med dine oplysninger, så vender vi hurtigt tilbage."
              />
            </div>

            {/* Højre kolonne: Kontaktoplysninger & Certifikationer */}
            <div className="lg:col-span-5 space-y-8">
              
              {/* Kontaktoplysninger Kort */}
              <div className="bg-white p-8 rounded-2xl border border-neutral-200 shadow-sm space-y-6">
                <div>
                  <h2 className="text-xl font-extrabold text-neutral-900 tracking-tight mb-1">
                    Kontaktoplysninger
                  </h2>
                  <span className="text-xs text-neutral-500 font-medium">
                    v/ Morten Chylenski
                  </span>
                </div>

                <div className="space-y-4 text-sm">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-neutral-100 text-neutral-800 flex items-center justify-center shrink-0">
                      <i className="fa-solid fa-phone" aria-hidden="true" />
                    </div>
                    <div>
                      <span className="text-xs text-neutral-500 block">Direkte telefon</span>
                      <a href="tel:50493950" className="text-base font-bold text-neutral-900 hover:text-neutral-600 no-break">
                        50 49 39 50
                      </a>
                    </div>
                  </div>

                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-neutral-100 text-neutral-800 flex items-center justify-center shrink-0">
                      <i className="fa-solid fa-envelope" aria-hidden="true" />
                    </div>
                    <div>
                      <span className="text-xs text-neutral-500 block">E-mail</span>
                      <a href="mailto:mc@fyat.dk" className="text-base font-medium text-neutral-900 hover:text-neutral-600 no-break">
                        mc@fyat.dk
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-lg bg-neutral-100 text-neutral-800 flex items-center justify-center shrink-0 mt-0.5">
                      <i className="fa-solid fa-location-dot" aria-hidden="true" />
                    </div>
                    <div>
                      <span className="text-xs text-neutral-500 block">Adresse</span>
                      <span className="text-base text-neutral-900 block font-medium">
                        Brolandvej 78<br />
                        5320 Agedrup (Odense)
                      </span>
                    </div>
                  </div>

                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-neutral-100 text-neutral-800 flex items-center justify-center shrink-0">
                      <i className="fa-solid fa-id-card" aria-hidden="true" />
                    </div>
                    <div>
                      <span className="text-xs text-neutral-500 block">CVR</span>
                      <span className="text-sm font-semibold text-neutral-900">
                        40617361
                      </span>
                    </div>
                  </div>
                </div>

                <div className="pt-4 border-t border-neutral-100 flex items-center gap-3">
                  <a
                    href="tel:50493950"
                    className="w-full bg-neutral-900 hover:bg-black text-white font-bold py-3.5 px-4 rounded-lg text-center text-sm shadow transition-colors block no-break"
                  >
                    <i className="fa-solid fa-phone mr-2 text-neutral-400" aria-hidden="true" />
                    <span className="no-break">Ring 50 49 39 50</span>
                  </a>
                </div>
              </div>

              {/* Certifikation & Speciale */}
              <div className="bg-[#0f141c] text-white p-8 rounded-2xl border border-neutral-800 shadow-xl space-y-4">
                <span className="text-xs font-bold uppercase tracking-widest text-neutral-400 block">
                  Kontrolinstans
                </span>
                
                <h3 className="text-xl font-extrabold text-white tracking-tight">
                  Validan Certifikation & Sikkerhedsstyrelsen
                </h3>

                <div className="bg-white p-3 rounded-lg inline-block shadow">
                  <img
                    src="/images/validan-logo.svg"
                    alt="Validan Kontrolinstans"
                    className="h-10 w-auto object-contain"
                  />
                </div>

                <p className="text-xs text-neutral-300 leading-relaxed">
                  Godkendt af Sikkerhedsstyrelsen som kontrolinstans inden for autorisationsområdet kloak.
                </p>

                <div className="pt-2 border-t border-neutral-800 space-y-2 text-xs text-neutral-300">
                  <span className="font-bold text-white block">Speciale:</span>
                  <ul className="space-y-1.5">
                    <li className="flex items-center gap-2">
                      <i className="fa-solid fa-check text-neutral-400" aria-hidden="true" />
                      <span>Rottesikring af kloaksystemer</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <i className="fa-solid fa-check text-neutral-400" aria-hidden="true" />
                      <span>Højvandslukke for sikring ved skybrud og opstuvning</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <i className="fa-solid fa-check text-neutral-400" aria-hidden="true" />
                      <span>Lovpligtigt serviceeftersyn af afløbsinstallationer</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <i className="fa-solid fa-check text-neutral-400" aria-hidden="true" />
                      <span>Røgprøvning for lokalisering af utætheder på afløb</span>
                    </li>
                  </ul>
                </div>
              </div>

            </div>

          </div>
        </div>
      </section>

      {/* Kort Sektion */}
      <section className="pb-20 bg-neutral-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white p-6 rounded-2xl border border-neutral-200 shadow-sm space-y-4">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
              <div>
                <h3 className="text-xl font-bold text-neutral-900 tracking-tight">
                  Find Fyns Afløbsteknik
                </h3>
                <p className="text-xs text-neutral-600">
                  Brolandvej 78, 5320 Agedrup – Centralt placeret til hurtig udkørsel på hele Fyn
                </p>
              </div>
              <a
                href="https://maps.google.com/maps?q=Brolandvej%2078%205320%20Odense%20Denmark"
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs font-bold text-neutral-900 underline hover:text-neutral-600 inline-flex items-center gap-1.5"
              >
                <span>Åbn i Google Maps</span>
                <i className="fa-solid fa-arrow-up-right-from-square text-[10px]" aria-hidden="true" />
              </a>
            </div>

            <div className="rounded-xl overflow-hidden border border-neutral-200 h-96 w-full">
              <iframe
                title="Google Maps Kort Fyns Afløbsteknik"
                src="https://maps.google.com/maps?q=Brolandvej%2078%205320%20Agedrup&t=&z=13&ie=UTF8&iwloc=&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
